































































































import { Component, Vue } from 'vue-property-decorator'
import { Member } from '@/types/Member.type'
import { namespace } from 'vuex-class'
import { UserRole } from '@/types/UserRole.type'
import RouteName from '@/utils/RouteName'
import { Spa2Route } from '@/ExternalRoutes'

const User = namespace('user')

@Component
export default class HeaderActionProfile extends Vue {
    @User.State me!: Member
    @User.Getter('isAdmin') isAdmin!: boolean
    @User.Getter hasRole!: (role: UserRole) => boolean

    Spa2Route = Spa2Route
    RouteName: typeof RouteName = RouteName
    displayClubs = false
    displayBenefits = false
    displayBusinessCenters = false
    displaySubmenu = false
    logout() {
        this.$store.dispatch('user/logout')
    }

    handleClubsDisplay() {
        this.displayClubs = !this.displayClubs
    }

    get networkUrl() {
        return `${process.env.VUE_APP_SPA2_BASE_URL}`
    }

    get exitSwitchToHref() {
        return process.env.VUE_APP_SPA2_BASE_URL + '/exit-switch-to'
    }

    get proUrl() {
        return `${process.env.VUE_APP_PRO_BASE_URL}`
    }

    get membershipUrl() {
        return process.env.VUE_APP_SPA2_BASE_URL + '/account/membership'
    }

    get updateAccountUrl() {
        return process.env.VUE_APP_SPA2_BASE_URL + '/account/info'
    }

    get getMer() {
        return process.env.VUE_APP_CLUB_BASE_URL + '/member'
    }

    get adminUrl() {
        return process.env.VUE_APP_ADMIN_BASE_URL + '/dashboard'
    }

    handleBusinessCentersDisplay() {
        this.displayBusinessCenters = !this.displayBusinessCenters
    }

    get isConnectedAsAdmin() {
        if (this.$store.state.user.decodedToken && this.$store.state.user.decodedToken.roles) {
            return this.$store.state.user.decodedToken.roles
        }

        return false
    }

    get isOnSwitchToMode() {
        try {
            const jwtDecoded = this.$store.getters['user/jwtTokenDecoded']

            return jwtDecoded?.roles?.some((role: string) => role === 'IS_IMPERSONATOR')
        } catch (e) {
            return false
        }
    }

    onClickRm() {
        window.analytics.track('leclub:rm')
    }
}
